<script>
export default {
  props: {
    title: {
      type: String,
      //   required: true,
      default: "informar sobre cvv"
    }
  },

  data() {
    showTooltip = "false";
  }
};
</script>

<template>
  <div class="tooltip" @click="showTooltip = !showTooltip">
      <div class="icon-information hidden-tip" v-bind:class="{ active: showTooltip }" :attr="title"></div>
  </div>
</template>

<style scoped>
.icon-information {
  background-image: url("/static/icon-information.svg");
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  right: -7px;
  top: -8px;
  padding: 20px;
}

.hidden-tip {
  transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}

.hidden-tip:before {
  content: attr(attr);
  background-color: #af006b;
  color: #fff;
  font-size: 12px;
  padding: 5px;
  box-sizing: border-box;
  font-family: "Roboto";
  position: absolute;
  right: 0;
  bottom: -26px;
  width: max-content;
  opacity: 0;
  transition: all 0.4s ease;
}

.hidden-tip:after {
  content: "";
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  right: 10px;
  bottom: -2px;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #af006b transparent;
  transition: all 0.4s ease;
}

.hidden-tip.active,
.hidden-tip:hover:after,
.hidden-tip:hover:before {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Tooltip.vue